'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utilsFont = require('./utils/font');

var _utilsFont2 = _interopRequireDefault(_utilsFont);

var React = require('react');
var _ = require('lodash');

var Renderer = function Renderer(props) {

	//empty content
	if (props.content === undefined || props.content.compiled === undefined) return React.createElement('span', {}, 'empty code');

	try {
		var _lodash = _;
		var self = undefined;
		var data = props.data;
		return React.createElement('div', { style: (0, _utilsFont2['default'])(props.font) }, eval(props.content.compiled));
	} catch (err) {
		//error content
		return React.createElement('span', {}, err.message);
	}
};

//Renderer.defaultProps = {content:'type your content'};
exports['default'] = Renderer;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-photo-widget-factory/lib/widgets/JsxRenderer.js
 ** module id = 2222
 ** module chunks = 0
 **/